import { Component, EventEmitter, Input, OnInit, Output, OnDestroy, ViewChild, ElementRef, HostListener } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ErrorMessageComponent } from '../../all-modals/error-message/error-message.component';
import { LITERALS } from 'src/app/core/constants/literals.constant';
declare var document: any;

@Component({
  selector: 'app-publication-preview',
  templateUrl: './publication-preview.component.html',
  styleUrls: ['./publication-preview.component.scss']
})
export class PublicationPreviewComponent implements OnInit, OnDestroy {
  @ViewChild('pdfViewer', { static: false }) pdfViewer: any;

  @Input() public url;
  @Input() public isAdvertisement;
  @Input() public materialAd;
  @Input() public fromModule;

  @Output() public closeAd = new EventEmitter();
  fullscreen = false;

  pdfView: String = "Single Page"
  page: number = 1;
  pdfSrc: string = "https://resources-is.s3.ap-south-1.amazonaws.com/529-Article+Text-2712-1-10-20130506.pdf";
  zoom: number = 1.0;
  pdflength: number = 1;
  showContinuous: Boolean = false;
  showTwoPage: Boolean = false;
  private errorContent: String = "Please try again later!";
  showPdf: Boolean = false;
  isCont: boolean = false;
  timer: number = 10;
  progress: number = 0;

  constructor(
    private activeModal: NgbActiveModal,
    private modalService: NgbModal
  ) { }

  ngOnInit() {

    // console.log(this.isAdvertisement +' , '+ this.materialAd.lable == 'publication')
    let HTMLTag = document.getElementsByTagName('html')[0]; // '0' to assign the first (and only `HTML` tag)
    HTMLTag.setAttribute('class', 'publication-preview-open');
    if (this.isAdvertisement && this.materialAd && this.materialAd.label == 'publication') {
      let timer = setInterval(() => {
        --this.timer;
        if (this.timer == 0) {
          clearInterval(timer);
          this.closeAd.emit(true);
        }
      }, 1000);
    }
  }
  /**
   * TODO : Zoom inc/dec
   * @param amount
   */
  incrementZoom(amount: number) {
    this.zoom += amount;
  }

  ngAfterViewInit() {

    document.getElementById('Mytest').addEventListener("fullscreenchange", () => {
      if (document.fullscreenElement) {
        this.fullscreen = true;
      } else {
        this.fullscreen = false;
      }
    });

    /* Firefox */
    document.getElementById('Mytest').addEventListener("mozfullscreenchange", () => {
      if (document.mozFullScreenElement) {
        this.fullscreen = true;
      } else {
        this.fullscreen = false;
      }
    });

    /* Chrome, Safari and Opera */
    document.getElementById('Mytest').addEventListener("webkitfullscreenchange", () => {
      if (document.webkitFullscreenElement) {
        // console.log(1);
        this.fullscreen = true;
      } else {
        this.fullscreen = false;
      }
    });
    /* IE / Edge */
    document.getElementById('Mytest').addEventListener("msfullscreenchange", () => {

      if (document.msFullscreenElement) {
        this.fullscreen = true;
      } else {
        this.fullscreen = false;
      }
    });
  }

  onProgress(progressData: { loaded: number, total: number }) {
    // do anything with progress data. For example progress indicator
    if (progressData.total != undefined) {
      this.progress = + ((progressData.loaded / progressData.total) * 100).toFixed(0);
    }
  }

  /**
   * TODO:Page change
   * @param num
   */
  incrementPlus(num: number) {
    if (this.page <= this.pdflength && this.page >= 0) {
      this.page += num;
    }
    else { return }
  }

  getInfullscreen() {
    if (this.fullscreen) {
      this.fullscreen = false;
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) { /* Firefox */
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) { /* Chrome, Safari and Opera */
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) { /* IE/Edge */
        document.msExitFullscreen();
      }
      return;
    }
    // let elem :any = this.pdfViewer.root.nativeElement;
    // viewerContainer
    this.fullscreen = true;

    let elem: any = document.getElementById('Mytest');
    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if (elem.mozRequestFullScreen) { /* Firefox */
      elem.mozRequestFullScreen();
    } else if (elem.webkitRequestFullscreen) { /* Chrome, Safari & Opera */
      elem.webkitRequestFullscreen();
    } else if (elem.msRequestFullscreen) { /* IE/Edge */
      elem.msRequestFullscreen();
    }
    return;
  }

  /**
   * TODO: check pdf metadata
   * @param pdf PDFDocumentProxy
   */
  callBackFn(pdf?) {
    // do anything with "pdf"
    if (pdf) {
      this.pdflength = pdf.numPages;
      this.showPdf = true;
      if (this.isAdvertisement && this.materialAd && this.materialAd.label == 'publication') {
        let timer = setInterval(() => {
          --this.timer;
          if (this.timer == 0) {
            clearInterval(timer);
            this.closeAd.emit(true);
          }
        }, 1000);
      }
    }
  }

  /**
   * TODO: close modal
   */
  closeDialog() {
    this.activeModal.dismiss();
  }

  /**
   * TODO: check pdf view type
   * @param $event
   */
  selectChange($event) {
    //In my case $event come with a id value
    if ($event == "Single Page") {
      this.showContinuous = false;
      this.showTwoPage = false;
      this.isCont = false;
    }
    else if ($event == "Continuous") {
      this.showContinuous = true;
      this.showTwoPage = false;
      this.isCont = true;
    }
    else {
      this.showTwoPage = true;
      this.showContinuous = false;
      this.isCont = false;
    }
  }

  onError(error?: any) {
    const modalRef = this.modalService.open(ErrorMessageComponent, { centered: true });
    modalRef.componentInstance.message = LITERALS.AUTH.ERROR_MESSAGES.SOMETHING_WENT_WRONG;
  }

  pageChange(event) {
    this.page = +event;
  }

  ngOnDestroy() {
    let HTMLTag = document.getElementsByTagName('html')[0]; // '0' to assign the first (and only `HTML` tag)
    HTMLTag.setAttribute('class', '');
  }

  pdfLoadingFailed(event) {
    // console.log(event);
    this.onError();
  }

}
